import { ContainerModule, interfaces, Container } from 'inversify';
import { TYPES } from '../constants';
import { GoService } from '../service';

export const goModule: (settings: any, pubsub?) => interfaces.ContainerModule =
    (settings) => new ContainerModule((bind: interfaces.Bind) => {
        bind(TYPES.LANGUAGE_TYPE_GO).to(GoService)
            .inSingletonScope();
    });
